import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import ProductDisplay from '../../components/product/product-display/product-display.component';
import ProductImages from '../../components/product/product-images/product-images.component';
import Spinner from '../../components/reusable/spinner/spinner.component';

import ClientHelper from '../../tools/client-helper';

import {
    BackLink,
    ContentContainer,
    MainContainer,
    MainTitle
} from '../../styles/page.styles';

const clientHelper = new ClientHelper();

const ProductPage = () => {
    const navigate = useNavigate();
    const [ loading, setLoading ] = useState(true);
    const { id } = useParams();
    const [ product, setProduct ] = useState('');

    useEffect(() => {
        getProduct();

        // eslint-disable-next-line
    }, []);

    const getProduct = async () => {
        setLoading(true);
        const res = await clientHelper.getProductById(id);

        if(res?.statusCode === 404) {
            setLoading(false);
            return
        }

        setProduct(res);
        setLoading(false);

        return res.data;
    }

    return (
        <MainContainer>
            <BackLink onClick={() => navigate(`/products`)}>
                Back To Products
            </BackLink>
            {loading ?
                <Spinner />
            :
                product.length === 0 ?
                    <MainTitle>No Product to Display</MainTitle>
                :
                    <ContentContainer>
                        <MainTitle>Product - {product.name}</MainTitle>
                        <ProductImages product={product} getProduct={getProduct} />
                        <ProductDisplay product={product} getProduct={getProduct} />
                    </ContentContainer>
            }
        </MainContainer>
    )
}

export default ProductPage;